module.exports = __webpack_public_path__ + "img/dauphinsexterieur18k.c96d810d.jpg";